import { CircularProgress, Backdrop } from "@mui/material";

export default function ProgressCom() {
  return (
    <Backdrop open={true} sx={{ zIndex: 10000 }}>
      <CircularProgress color="secondary" />
    </Backdrop>
  );
}
